<!--
 * @Author: xiaokun
 * @Date: 2020-04-10 19:40:06
 * @LastEditors: xiaokun
 * @LastEditTime: 2020-04-16 18:27:09
 * @Description: 新增/编辑 试题管理组件
 -->
<template>
  <div
    ref="paperManage"
    class="paper-manage"
  >
    <!-- 左侧分数设置 -->
    <left-score-setting ref="leftScoreSetting" />
    <!-- 右侧试题列表 -->
    <right-test-questions ref="rightTestQuestion" />
  </div>
</template>
<script>
import LeftScoreSetting from './components/left-score-setting'
import RightTestQuestions from './components/right-test-questions'
export default {
  name: 'PaperManage',
  components: { LeftScoreSetting, RightTestQuestions },
  props: {},
  data () {
    return {}
  },
  watch: {},
  created () {},
  mounted () {},
  methods: {
    // 编辑时 父级数据回显
    setData (data) {
      this.$refs.leftScoreSetting.setData(data)
      this.$refs.rightTestQuestion.setData(data)
    },
    returnData () {
      let passScore = this.$refs.leftScoreSetting.returnPassScore()
      let questions = this.$refs.rightTestQuestion.submitFormReturnQuestions()
      let paperManageData = {
        questions, passScore
      }
      return paperManageData
    }
  }
}
</script>
<style lang='scss' scoped>
.paper-manage {
  display: flex;
  padding: 0 20px;

  /deep/ .border-attribute {
    border-radius: 4px;
    border: 1px solid rgba(232, 232, 232, 1);
  }

  /deep/.el-input-number {
    height: 28px !important;

    .el-input__inner {
      padding: 0;
    }
  }
}
</style>
